// libs
import React, { Suspense } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
// components
import { Box, BoxProps, Typography } from '@lyearn/ui';

import Toolbar from '../../../components/Toolbar';
// context
import { EditorContext } from '../../../context';
// hooks
import useEditor from '../../hooks/useEditor';
// types
import { EditorProps } from '../../types';
import AttachmentContainer from '../AttachmentContainer';
import EditorCore from '../EditorCore';

type Props = EditorProps & BoxProps;

const Editor: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const {
    value,
    placeholder = t('Common:EditorPlaceholder'),
    children,
    className,
    medias,
    disabled,
    ...rest
  } = props;

  const editorContext = useEditor({
    value: value ?? '',
    placeholder: placeholder,
    medias: medias || [],
    readOnly: disabled ?? false,
    ...rest,
  });

  return (
    <EditorContext.Provider value={editorContext}>
      <Box
        className={cn(className, {
          'bg-bg-secondary': disabled,
        })}>
        {children}
        {editorContext.remainingChar ? (
          <Typography
            className="absolute bottom-8 end-20"
            color="text-text-placeholder"
            variant="body-short-01">
            {editorContext.remainingChar}
          </Typography>
        ) : null}
      </Box>
    </EditorContext.Provider>
  );
};

const EditorContainer: React.FC<Props> = (props) => {
  useTranslation('Lygo');

  return (
    <Suspense fallback={null}>
      <Editor {...props} />
    </Suspense>
  );
};

export { AttachmentContainer, EditorCore, EditorContainer as Main, Toolbar };
